export default __webpack_public_path__ + "static/media/early-return-icon.831627fa.svg";